import HandHeartSvg from '@assets/images/svg/hand-heart.svg';
import React from 'react';

export interface HandHeartIconProps {
  size?: number;
  color?: string;
}

export const HandHeartIcon = React.memo<HandHeartIconProps>(function HandHeartIcon({
  size = 40,
  color = '#333333',
}) {
  return <HandHeartSvg width={size} height={size} color={color} />;
});

export default HandHeartIcon;

